import React from "react";
import { Button, Modal } from "react-bootstrap";
import SwapsSummaryTable from "./SwapsSummaryTable";

interface ModalConfirmSwapsProps {
  show: boolean;
  swaps: any[];
  isSaving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ModalConfirmSwaps: React.FC<ModalConfirmSwapsProps> = ({
  show,
  swaps,
  isSaving,
  onCancel,
  onConfirm,
}) => (
  <Modal show={show} onHide={onCancel}>
    <Modal.Header closeButton>
      <Modal.Title>Confirmar cambios</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <SwapsSummaryTable swaps={swaps} />
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel}>
        Cancelar
      </Button>
      <Button variant="success" onClick={onConfirm} disabled={isSaving}>
        Confirmar
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ModalConfirmSwaps;
